export default __webpack_public_path__ + "static/media/moreOpen.ceb854fb.svg";